/**
 * https://www.pdftron.com/api/web/Core.isFullPDFEnabled.html#isFullPDFEnabled__anchor
 */
export default () => window.Core.isFullPDFEnabled();
